import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=36f87848&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=ts"
export * from "./RoleEdit.vue?vue&type=script&lang=ts"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=36f87848&prod&lang=css"
import style1 from "./RoleEdit.vue?vue&type=style&index=1&id=36f87848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f87848",
  null
  
)

export default component.exports